module.exports = __webpack_public_path__ + "img/gender.f557be72.svg";